export default {
  header: "Contact Us Here!",
  view: "Contact"
};
